/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { GeneratedRoute } from '@elegant-router/types';

export const generatedRoutes: GeneratedRoute[] = [
  {
    name: '403',
    path: '/403',
    component: 'layout.base$view.403',
    meta: {
      title: '403',
      i18nKey: 'route.403',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '404',
    path: '/404',
    component: 'layout.base$view.404',
    meta: {
      title: '404',
      i18nKey: 'route.404',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '500',
    path: '/500',
    component: 'layout.base$view.500',
    meta: {
      title: '500',
      i18nKey: 'route.500',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'ecommerce',
    path: '/ecommerce',
    component: 'layout.base',
    meta: {
      title: 'ecommerce',
      i18nKey: 'route.ecommerce'
    },
    children: [
      {
        name: 'ecommerce_aigc-prompt-template',
        path: '/ecommerce/aigc-prompt-template',
        component: 'view.ecommerce_aigc-prompt-template',
        meta: {
          title: 'ecommerce_aigc-prompt-template',
          i18nKey: 'route.ecommerce_aigc-prompt-template'
        }
      },
      {
        name: 'ecommerce_conversation',
        path: '/ecommerce/conversation',
        component: 'view.ecommerce_conversation',
        meta: {
          title: 'ecommerce_conversation',
          i18nKey: 'route.ecommerce_conversation'
        }
      },
      {
        name: 'ecommerce_conversation-chat',
        path: '/ecommerce/conversation-chat/:id',
        component: 'view.ecommerce_conversation-chat',
        props: true,
        meta: {
          title: 'ecommerce_conversation-chat',
          i18nKey: 'route.ecommerce_conversation-chat',
          hideInMenu: true,
          activeMenu: 'ecommerce_conversation'
        }
      },
      {
        name: 'ecommerce_order',
        path: '/ecommerce/order',
        component: 'view.ecommerce_order',
        meta: {
          title: 'ecommerce_order',
          i18nKey: 'route.ecommerce_order'
        }
      },
      {
        name: 'ecommerce_payment',
        path: '/ecommerce/payment',
        component: 'view.ecommerce_payment',
        meta: {
          title: 'ecommerce_payment',
          i18nKey: 'route.ecommerce_payment'
        }
      },
      {
        name: 'ecommerce_player',
        path: '/ecommerce/player',
        component: 'view.ecommerce_player',
        meta: {
          title: 'ecommerce_player',
          i18nKey: 'route.ecommerce_player'
        }
      },
      {
        name: 'ecommerce_player-detail',
        path: '/ecommerce/player-detail/:id',
        component: 'view.ecommerce_player-detail',
        meta: {
          title: 'ecommerce_player-detail',
          i18nKey: 'route.ecommerce_player-detail'
        }
      },
      {
        name: 'ecommerce_points',
        path: '/ecommerce/points',
        component: 'view.ecommerce_points',
        meta: {
          title: 'ecommerce_points',
          i18nKey: 'route.ecommerce_points'
        }
      },
      {
        name: 'ecommerce_product',
        path: '/ecommerce/product',
        component: 'view.ecommerce_product',
        meta: {
          title: 'ecommerce_product',
          i18nKey: 'route.ecommerce_product'
        }
      },
      {
        name: 'ecommerce_video-pool',
        path: '/ecommerce/video-pool',
        component: 'view.ecommerce_video-pool',
        meta: {
          title: 'ecommerce_video-pool',
          i18nKey: 'route.ecommerce_video-pool'
        }
      },
      {
        name: 'ecommerce_video-scene-config',
        path: '/ecommerce/video-scene-config',
        component: 'view.ecommerce_video-scene-config',
        meta: {
          title: 'ecommerce_video-scene-config',
          i18nKey: 'route.ecommerce_video-scene-config'
        }
      },
      {
        name: 'ecommerce_virtual-partner',
        path: '/ecommerce/virtual-partner',
        component: 'view.ecommerce_virtual-partner',
        meta: {
          title: 'ecommerce_virtual-partner',
          i18nKey: 'route.ecommerce_virtual-partner'
        }
      }
    ]
  },
  {
    name: 'home',
    path: '/home',
    component: 'layout.base$view.home',
    meta: {
      title: 'home',
      i18nKey: 'route.home'
    }
  },
  {
    name: 'iframe-page',
    path: '/iframe-page/:url',
    component: 'layout.base$view.iframe-page',
    props: true,
    meta: {
      title: 'iframe-page',
      i18nKey: 'route.iframe-page'
    }
  },
  {
    name: 'login',
    path: '/login/:module(pwd-login|code-login|register|reset-pwd|bind-wechat)?',
    component: 'layout.blank$view.login',
    props: true,
    meta: {
      title: 'login',
      i18nKey: 'route.login',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'manage',
    path: '/manage',
    component: 'layout.base',
    meta: {
      title: 'manage',
      i18nKey: 'route.manage'
    },
    children: [
      {
        name: 'manage_aigc-config',
        path: '/manage/aigc-config',
        component: 'view.manage_aigc-config',
        meta: {
          title: 'manage_aigc-config',
          i18nKey: 'route.manage_aigc-config'
        }
      },
      {
        name: 'manage_cache-list',
        path: '/manage/cache-list',
        component: 'view.manage_cache-list',
        meta: {
          title: 'manage_cache-list',
          i18nKey: 'route.manage_cache-list'
        }
      },
      {
        name: 'manage_cache-monitor',
        path: '/manage/cache-monitor',
        component: 'view.manage_cache-monitor',
        meta: {
          title: 'manage_cache-monitor',
          i18nKey: 'route.manage_cache-monitor'
        }
      },
      {
        name: 'manage_config',
        path: '/manage/config',
        component: 'view.manage_config',
        meta: {
          title: 'manage_config',
          i18nKey: 'route.manage_config'
        }
      },
      {
        name: 'manage_dept',
        path: '/manage/dept',
        component: 'view.manage_dept',
        meta: {
          title: 'manage_dept',
          i18nKey: 'route.manage_dept'
        }
      },
      {
        name: 'manage_dict',
        path: '/manage/dict',
        component: 'view.manage_dict',
        meta: {
          title: 'manage_dict',
          i18nKey: 'route.manage_dict'
        }
      },
      {
        name: 'manage_email-config',
        path: '/manage/email-config',
        component: 'view.manage_email-config',
        meta: {
          title: 'manage_email-config',
          i18nKey: 'route.manage_email-config'
        }
      },
      {
        name: 'manage_file-manage',
        path: '/manage/file-manage',
        component: 'view.manage_file-manage',
        meta: {
          title: 'manage_file-manage',
          i18nKey: 'route.manage_file-manage'
        }
      },
      {
        name: 'manage_job',
        path: '/manage/job',
        component: 'view.manage_job',
        meta: {
          title: 'manage_job',
          i18nKey: 'route.manage_job'
        }
      },
      {
        name: 'manage_job-log',
        path: '/manage/job-log',
        component: 'view.manage_job-log',
        meta: {
          title: 'manage_job-log',
          i18nKey: 'route.manage_job-log'
        }
      },
      {
        name: 'manage_login-log',
        path: '/manage/login-log',
        component: 'view.manage_login-log',
        meta: {
          title: 'manage_login-log',
          i18nKey: 'route.manage_login-log'
        }
      },
      {
        name: 'manage_menu',
        path: '/manage/menu',
        component: 'view.manage_menu',
        meta: {
          title: 'manage_menu',
          i18nKey: 'route.manage_menu'
        }
      },
      {
        name: 'manage_operation-log',
        path: '/manage/operation-log',
        component: 'view.manage_operation-log',
        meta: {
          title: 'manage_operation-log',
          i18nKey: 'route.manage_operation-log'
        }
      },
      {
        name: 'manage_oss-config',
        path: '/manage/oss-config',
        component: 'view.manage_oss-config',
        meta: {
          title: 'manage_oss-config',
          i18nKey: 'route.manage_oss-config'
        }
      },
      {
        name: 'manage_post',
        path: '/manage/post',
        component: 'view.manage_post',
        meta: {
          title: 'manage_post',
          i18nKey: 'route.manage_post'
        }
      },
      {
        name: 'manage_role',
        path: '/manage/role',
        component: 'view.manage_role',
        meta: {
          title: 'manage_role',
          i18nKey: 'route.manage_role'
        }
      },
      {
        name: 'manage_system-monitor',
        path: '/manage/system-monitor',
        component: 'view.manage_system-monitor',
        meta: {
          title: 'manage_system-monitor',
          i18nKey: 'route.manage_system-monitor'
        }
      },
      {
        name: 'manage_user',
        path: '/manage/user',
        component: 'view.manage_user',
        meta: {
          title: 'manage_user',
          i18nKey: 'route.manage_user'
        }
      },
      {
        name: 'manage_user-detail',
        path: '/manage/user-detail/:id',
        component: 'view.manage_user-detail',
        meta: {
          title: 'manage_user-detail',
          i18nKey: 'route.manage_user-detail'
        }
      }
    ]
  },
  {
    name: 'payment',
    path: '/payment',
    component: 'layout.base',
    meta: {
      title: 'payment',
      i18nKey: 'route.payment'
    },
    children: [
      {
        name: 'payment_config',
        path: '/payment/config',
        component: 'view.payment_config',
        meta: {
          title: 'payment_config',
          i18nKey: 'route.payment_config'
        }
      },
      {
        name: 'payment_webhook-log',
        path: '/payment/webhook-log',
        component: 'view.payment_webhook-log',
        meta: {
          title: 'payment_webhook-log',
          i18nKey: 'route.payment_webhook-log'
        }
      }
    ]
  },
  {
    name: 'user-center',
    path: '/user-center',
    component: 'layout.base$view.user-center',
    meta: {
      title: 'user-center',
      i18nKey: 'route.user-center'
    }
  }
];
